<template>
  <v-layout wrap>
    <v-flex xs12 :md6="!embedded" :md12="embedded">
      <v-layout column>
        <v-select
          :items="cascadingOptions"
          box
          :label="fieldLabel"
          v-model="selection"
          :disabled="readonly"
          no-data-text="No results"
          dense
          append-icon="keyboard_arrow_down"
          clearable>
        </v-select>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"

export default {
  name: 'cascading-options-field',
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    },
    tableName: {
      type: String
    }
  },
  computed: {
    ...mapState({
      parentValue: function (state) {
        if (!this.embedded) {
          return state.cases.currentlySelected.case.properties[this.field.cascading_parent_field] || null
        } else {
          const table = state.cases.currentlySelected.case.properties[this.tableName]
          if (table && table[this.row] && table[this.row][this.field.cascading_parent_field]) {
            return table[this.row][this.field.cascading_parent_field]
          }
        }
        return null
      }
    }),
    cascadingOptions() {
      const cascadingOptions = (this.field.cascading_options || []).find(cOption => cOption.parent_field_option === this.parentValue)
      return (cascadingOptions) ? cascadingOptions.options || [] : []
    },
    readonly() {
      return (this.field && this.field.readonly) ? this.field.readonly : false
    },
    fieldLabel() {
      return (this.field.display_name) ? this.field.display_name : Helpers.capitalizeRemoveUnderscores(this.field.name)
    },
    selection: {
      get() {
        if (this.data) {
          return this.data
        } else {
          return (this.field.default_value) ? this.field.default_value : ""
        }
      },
      set(value) {
        this.$emit('update-item', { field: this.field.name, data: value, row: this.row })
        this.$emit("blurred", {
          field: this.field.name,
          data: value,
          row: this.row
        })
      }
    }
  },
  watch: {
    parentValue() {
      this.selection = ""
    }
  }
}
</script>
